import type { HttpTransport, RequestOptions, UploadOptions } from "@common/api/transport";

import { jsonFetch, jsonMutate } from "../client";

import { uploadFormData } from "./uploadFormData";

const mutate = <T>(
  url: string,
  body: unknown,
  method: string,
  opts?: RequestOptions
): Promise<T> =>
  jsonMutate<T>(url, (body ?? {}) as Record<string, unknown>, {
    method,
    ...(opts?.headers ? { headers: opts.headers } : {})
  }) as Promise<T>;

/**
 * Web transport: `fetch` + cookie auth (`credentials: "include"`), backed by the
 * existing `client.ts` primitives. Those primitives are an implementation detail
 * of this binding and are not part of the public api surface.
 */
export const fetchTransport: HttpTransport = {
  del: <T>(url: string, body?: unknown, opts?: RequestOptions) =>
    mutate<T>(url, body, "DELETE", opts),
  get: <T>(url: string, opts?: RequestOptions) => jsonFetch<T>(url, opts),
  patch: <T>(url: string, body?: unknown, opts?: RequestOptions) =>
    mutate<T>(url, body, "PATCH", opts),
  post: <T>(url: string, body?: unknown, opts?: RequestOptions) =>
    mutate<T>(url, body, "POST", opts),
  put: <T>(url: string, body?: unknown, opts?: RequestOptions) =>
    mutate<T>(url, body, "PUT", opts),
  upload: <T>(url: string, formData: FormData, opts?: UploadOptions) =>
    uploadFormData<T>({
      formData,
      method: opts?.method ?? "POST",
      onUploadProgress: opts?.onUploadProgress,
      url
    })
};
